import { render, staticRenderFns } from "./DadosEmpregaticios.vue?vue&type=template&id=0e2bb878"
import script from "./DadosEmpregaticios.vue?vue&type=script&lang=js"
export * from "./DadosEmpregaticios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports